<template>
  <div class="greeting" :style="{'margin-top': marginTop || '40px'}">
    <div class="bubble">
      <img src="/images/greeting.png" class="wave" v-if="wave" />
      <div class="text">
        <span class="strong" v-if="boldMessage">{{ boldMessage }}</span>&nbsp;
        <span v-html="message"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Greeting",
  props: ["wave", "boldMessage", "message", "marginTop"],
};
</script>

<style scoped lang="scss">
.greeting {
  margin: 40px 0 0 0;
  text-align: left;
  font-family: $font-family;
}

.bubble {
  display: inline-block;
  background: #fff;
  /* box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.302),
    0 1px 3px 1px rgba(60, 64, 67, 0.149); */
  border: 0px solid #ddd;
  border-radius: 16px;
  padding: 8px 0 0 0px;
  text-align: left;
  //padding: 10px 16px 8px 16px;
}

.wave {
  width: 25px;
  float: left;
  margin-top: 0px;
  margin-right: 4px;
}

.text {
  float: left;
  padding-left: 0em;
  font-size: 12pt;
  color: #222;
}
.strong {
  font-weight: 700;
}
</style>


